<template>

  <modalo
    :title="$t('Invite new member')"
    type="mini"
    @hideModal="hideModal()">
    <form id="memberInvite-form" v-on:submit.prevent="updateMemberInvite(memberInvite)">
      <div class="form-group">
        <label>{{ $t('Email') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="memberInvite.email"
          disabled>
        <ValidateMessage :error="validateErrors.email" />
      </div>
      <div class="form-group">
        <label>{{ $t('Role') }}</label>
        <select-role
          v-model="memberInvite.role_id">
          </select-role>
        <ValidateMessage :error="validateErrors.role_id" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="memberInvite-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
          type="button"
          class="btn btn-danger"
          @click="deleteMemberInvite(memberInvite._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectRole from '@/components/Fields/SelectRole'

export default {
  name: 'MemberInviteForm',
  components: {
    SelectRole
  },
  props: [
    'initMemberInvite'
  ],
  data () {
    return {
      loading: false,
      memberInvite: this.defaultValues(this.initMemberInvite),
      validateErrors: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    updateMemberInvite
    */
    updateMemberInvite (data) {
      this.loading = true

      this.$store
      .dispatch('updateMemberInvite', data)
      .then(() => {
        this.$emit('saved')
      })
      .catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    },
    /*
    delete
    */
    deleteMemberInvite (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteMemberInvite', id)
        .then(() => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store.dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberInviteEdit.vue